module.exports = __webpack_public_path__ + "img/1F1EE-1F1F8.2813d7cb.svg";